import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    CmpsBadgeModule,
    CmpsButtonGroupModule,
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsPortalModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsSingleDecimalPointModule } from '../../common/pipe/single-decimal-point';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../../route.module';

import { ActionPickerComponent } from './component/action-picker.component';
import { ActionComponent } from './component/action.component';
import { FilterComponent } from './component/filter/filter.component';
import { GpGridComponent } from './component/gp-grid.component';
import { GpLaneComponent } from './component/gp-lane.component';
import { GpLegendDialogComponent } from './component/gp-legend-dialog.component';
import { GpPersonaTileComponent } from './component/gp-persona-tile.component';
import { NoActionComponent } from './component/no-action.component';
import { SearchInputDirective } from './directive/search-input.directive';
import { GamePlanRoutes } from './game-plan.route';
import { GpMainComponent } from './gp-main.component';
import { TranslationIdMap } from './gp-main.i18n';

@NgModule({
    declarations: [
        ActionComponent,
        ActionPickerComponent,
        FilterComponent,
        GpGridComponent,
        GpLaneComponent,
        GpLegendDialogComponent,
        GpMainComponent,
        GpPersonaTileComponent,
        NoActionComponent,
        SearchInputDirective,
    ],
    imports: [
        CmpsBadgeModule,
        CmpsButtonGroupModule,
        CmpsButtonModule,
        CmpsCheckboxModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsLazyRouterModule.forChild(GamePlanRoutes),
        CmpsPortalModule,
        CmpsSingleDecimalPointModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
    ],
})
export class CmpsGamePlanModule {}
